<template>
  <div class="in-sale-item">
    <div
      class="item"
      @click="
        $router.push({
          name: 'OrderInSale',
          query: { id: source.id, noPurchase: source.noPurchase },
        })
      "
    >
      <div class="body">
        <!-- 只有一个图片的 -->
        <div v-if="source.items.length === 1" style="width: 100%">
          <div
            v-for="(item, index) in source.items"
            :key="source.orderNo + index"
            class="flex flex-row mb-3 items-center"
          >
            <!-- //左侧图片 -->
            <div
              class="flex-shrink-0 flex-grow-0 rounded-md overflow-hidden"
              style="height: 66px; width: 66px"
            >
              <img class="w-full h-full" :src="item.goodsInfoImg" alt />
            </div>
            <!-- 列表内容 -->
            <div
              class="flex-grow flex flex-col ml-2 text-left justify-between"
              style="height: 66px"
            >
              <div
                class="text-sm flex-shrink-0 flex-grow-0"
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  line-height: unset !important;
                "
              >
                <span
                  style="font-size: 12px; font-weight: 400; color: #000000"
                  >{{ item.goodsInfoName }}</span
                >
              </div>

              <!-- //价格 -->
              <div>
                <span>x</span>
                <span class>{{ item.qty }}</span>
              </div>
              <!-- 底部 -->
              <div class="flex justify-between items-center">
                <!-- 底部最左侧 -->
                <div class="flex items-center flex-shrink-0">
                  <div
                    class="font-xxxs"
                    style="
                      width: 5rem;
                      display: inline-block;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ item.spec || null }}
                  </div>
                </div>
                <!-- 底部最右侧 -->
                <div class="flex flex-row items-center flex-shrink-0">
                  <div class="flex items-center statusOneImg font-semibold">
                    <!-- 待发货状态中，物流是备货中，用于锁单-->
                    <span
                      v-if="
                        source.state === 'PAID' &&
                        source.deliverState === 'PREPARING'
                      "
                      >备货中</span
                    >
                    <!-- 待发货状态中，物流非备货中 -->
                    <span v-else>{{ states[source.state] }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 有多个图片的 -->
        <div
          v-else-if="source.items.length > 1"
          :class="{ manyImglistContant: source.items.length > 1 }"
        >
          <div class="img-list">
            <div
              v-for="(item, index) in source.items"
              :key="source.orderNo + index"
              v-show="index < 3"
              class="img"
              :style="{
                backgroundImage: 'url(' + item.goodsInfoImg + ')',
              }"
            ></div>
            <div class="more" v-show="source.items.length > 3">…</div>
          </div>
          <div class="status">
            <div class="count">共{{ source.orderItemTotal }}种</div>
            <div class="value font-semibold">
              <span
                v-if="
                  source.state === 'PAID' && source.deliverState === 'PREPARING'
                "
                >备货中</span
              >
              <span v-else>{{ states[source.state] }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom van-hairline--top">
        <div class="detail">
          <div class="amount font-semibold">
            ¥&nbsp;{{ source.actualPayAmount }}
            <span v-distributor="true" class="text-red ml-1"
              >返现：{{ source.saveProfit }}</span
            >
          </div>
        </div>

        <div class="flex items-center">
          <!-- 待发货中如果是备发货（PREPARING：'备货中'），取消订单按钮消失 -->
          <div
            class="btn-white"
            v-if="
              source.state === 'INITIAL' ||
              (source.state === 'PAID' && source.deliverState !== 'PREPARING')
            "
            @click.stop="
              $router.push({
                name: 'OrderInSale',
                query: { id: source.id, goto: '取消订单' },
              })
            "
          >
            取消订单
          </div>
          <template v-if="source.state === 'INITIAL'">
            <div v-if="source.noPurchase === true" class="no-purchase">
              超出活动限购
            </div>
            <div
              v-else
              class="btn ml-1"
              @click.stop="
                $router.push({
                  name: 'OrderInSale',
                  query: {
                    id: source.id,
                    goto: '去付款',
                    noPurchase: source.noPurchase,
                  },
                })
              "
            >
              去付款
            </div>
          </template>
          <div
            class="btn-white"
            v-if="source.state === 'SHIPPED' || source.state === 'COMPLETED'"
            @click.stop="
              $router.push({
                name: 'OrderInSale',
                query: { id: source.id, goto: '查看物流' },
              })
            "
          >
            查看物流
          </div>
          <div class="btn ml-1" v-if="source.state === 'SHIPPED'">确认收货</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      states: {
        INITIAL: "待付款",
        PAID: "待发货",
        SHIPPED: "待收货",
        COMPLETED: "已完成",
        CLOSED: "已关闭",
      },
    };
  },
  computed: {
    ...mapState({
      inSaleOrderState: (state) => state.options.inSaleOrderState,
    }),
  },
};
</script>

<style lang="less" scoped>
.in-sale-item {
  padding: 24px 24px 0;
  .item {
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    .head {
      font-size: 24px;
      color: #666666;
      line-height: 34px;
      padding: 28px 36px 26px;
    }
    .body {
      display: flex;
      justify-content: space-between;
      padding: 38px 32px 28px;
      .img-list {
        display: flex;
        align-items: flex-end;
        .img {
          width: 132px;
          height: 132px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          margin-right: 12px;
        }
        .more {
          font-size: 34px;
          color: #999999;
          line-height: 48px;
        }
      }
      .status {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        .value {
          font-size: 28px;
          line-height: 28px;
        }
        .count {
          font-size: 24px;
          color: #999999;
          line-height: 24px;
        }
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding: 28px 32px 28px 36px;
      .detail {
        font-size: 28px;
        line-height: 28px;
        .amount {
        }
        .time {
          padding-top: 28px;
        }
      }
      .btn {
        background: #e82035;
        color: #fff;
        padding: 12px 24px;
        border-radius: 48px;
        font-size: 24px;
        line-height: 24px;
      }
      .btn-white {
        border: 1px black solid;
        padding: 10px 24px;
        border-radius: 48px;
        font-size: 24px;
        line-height: 24px;
      }
    }
  }
}
.no-purchase {
  margin-left: 20px;
  color: #acacac;
  font-size: 24px;
}

.manyImglistContant {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.statusOneImg {
  font-size: 28px;
  line-height: 28px;
}
</style>
